import { motion } from "framer-motion";

const Hero = () => {
  return (
    <header className="pt-28 pb-8">
      <div className="max-w-5xl mx-auto px-6">
        {/* === Centered Logo === */}
        <div className="flex justify-center mb-8">
          <motion.div
            className="relative inline-block"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            {/* Steam Glow Animation */}
            <motion.div
              className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 rounded-full
                         bg-gradient-to-b from-[#4b5fff]/30 to-transparent blur-2xl opacity-30 hidden sm:block"
              animate={{ opacity: [0.25, 0.45, 0.25] }}
              transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
            />
          </motion.div>
        </div>

        {/* === Text Block (Left-Aligned) === */}
        <div className="text-left">
          <motion.h1
            className="text-5xl md:text-6xl font-bold mb-3
                       bg-gradient-to-r from-[#00e0b7] via-[#4b5fff] to-[#b45eff]
                       bg-clip-text text-transparent font-display
                       drop-shadow-[0_0_6px_rgba(75,95,255,0.25)]"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Devish Mundra
          </motion.h1>

          <p className="text-lg md:text-xl text-slate-200 mb-4">
            Data Engineer · Cloud Lakehouse Architect
          </p>

          <p className="text-slate-400 max-w-3xl leading-relaxed text-[15px] md:text-base mb-6">
            From ingestion to insight, I build resilient, governed data systems for any cloud.
            Specializing in Databricks, Delta Lake, Spark (Scala/Python), Terraform, and
            cloud-native lakehouse architectures that make complex data reliable, explainable, and fast.
          </p>

          {/* === Call-to-Action Buttons === */}
          <div className="flex flex-wrap gap-4">
            {[
              { label: "View Projects", href: "#projects" },
              { label: "Resume", href: "/Devish_Mundra_Resume.pdf" },
              { label: "Blogs", href: "/blog" },
            ].map((btn) => (
              <a
                key={btn.label}
                href={btn.href}
                className="px-6 py-2 rounded-full bg-gradient-to-r from-[#00e0b7] to-[#4b5fff]
                           text-white font-semibold shadow-md hover:shadow-[0_0_18px_rgba(0,224,183,0.25)]
                           hover:-translate-y-0.5 transition-transform duration-300"
              >
                {btn.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Hero;
